import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=349bb462&scoped=true"
import script from "./JoinUs.vue?vue&type=script&lang=js"
export * from "./JoinUs.vue?vue&type=script&lang=js"
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=349bb462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349bb462",
  null
  
)

export default component.exports